export type HttpError = {
    status: number
    code: string
    detail?: string
}

export type AxiosHttpError = {
    response: {
        data: any
        status: number
    }
}

export const extractHttpError = (err: AxiosHttpError): HttpError => ({
    status: err.response?.status,
    code: err.response?.data?.code,
    detail:
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error
})
